require('./style.scss')
angular = require('angular')
pkg = angular.module('cdms.device.details', [require('angular-ui-router'), require('../configurator'), require('../screenshot')])  
  .config ($stateProvider) ->
    $stateProvider
      .state 'devices.details',
        url: "/:_id"         
        authenicate: true   
        views:
          "@":             
            template: require('./index.pug') 
            controller: 'DeviceDetailsCtrl' 
  .controller('DeviceDetailsCtrl', require("./controller"))
  .filter "reservedApp", ()->
    return (apps)->
      out = []
      if apps
        apps.forEach (app)->      
          if app.packageName.startsWith("com.cenique") or app.packageName.startsWith("com.inreality") or app.packageName.startsWith("com.enplug") or app.packageName.startsWith("com.spectrio") or app.packageName.startsWith("com.tenfootwave") or app.packageName.startsWith("com.ciere") or app.packageName.startsWith("spectrio") or app.packageName.startsWith("com.gocodigo")
            out.push app
          
      return out

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/details/index.coffee